<!-- 客户预付款 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">供应商名称</div>
                <el-select
                    size="small"
                    v-model="searchData.CusId"
                    filterable
                    clearable
                    remote
                    reserve-keyword
                    :remote-method="querySearch"
                    v-select-scroll-more="searchLoad"
                    class="search-item"
                >
                    <el-option v-for="optionItem in cusOptions" :key="optionItem.EntpCusId" :data-msg="optionItem" :label="optionItem.EntpCusName" :value="optionItem.EntpCusId">
                    </el-option>
                </el-select>
                <div class="search-name">收款时间</div>
                <el-date-picker
                    class="search-item"
                    style="width: 230px"
                    size="small"
                    v-model="datetime2"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    :picker-options="pickerOptions"
                    @change="onDate2TimeSelect"
                ></el-date-picker>                    
                 <div class="search-name">操作时间</div>
                    <el-date-picker
                        class="search-item"
                        style="width:230px;"
                        size="small"
                        v-model="datetime1"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        :picker-options="pickerOptions"
                        @change="onDate1TimeSelect"
                    ></el-date-picker>                   
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" style="margin-left:10px;" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printPreview()">打印</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">预付总额：{{ total.toFixed(2) }} ，剩余预付款：{{ advanMoney.toFixed(2) }}</div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%; margin-bottom: 0px;">
                <el-table-column show-overflow-tooltip width="180px" prop="PayCode" label="预付款单号"></el-table-column>
                <el-table-column show-overflow-tooltip width="120px" prop="EntpCusName" label="供应商"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="PayTypeName" label="支付方式"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="SumPayable" label="预付款金额"></el-table-column>
                <el-table-column show-overflow-tooltip width="95px" prop="PayTime" label="付款时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="70px" prop="ApplyName" label="操作人"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="操作时间"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100px" prop="Remark" label="备注"></el-table-column>
                <el-table-column label="操作" width="70px">
                   <template slot-scope="scope">
                        <div class="ops-ctn" v-if="(permission1.cancelApply || permission2.cancelApply) && !scope.row.IsConfirm && !scope.row.IsCancel">
                            <el-button title="撤销" size="mini" type="text" @click="cancelPayRecord(scope.row.Id)">撤销</el-button>
                        </div>
                        <div class="ops-ctn" v-else-if="!scope.row.IsConfirm && scope.row.IsCancel">已撤销</div>
                        <div class="ops-ctn" v-else-if="!(permission1.backState || permission2.backState) && scope.row.IsConfirm && !scope.row.IsCancel">已确认</div>
                        <div class="ops-ctn" v-if="(permission1.backState || permission2.backState) && scope.row.IsConfirm && !scope.row.IsCancel">
                            <el-button title="反结算" style="color: red" size="mini" type="text" @click="backState(scope.row.Id)">反结算</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="打印" :modal="false" :before-close="closePrintDialog" :visible.sync="printPreviews" width="870px">
            <div class="dialog-content" v-if="printPreviews">
                <printAdvancePayment @closeDialog="closePrintDialog" :sParams="searchData" :isInit="true"></printAdvancePayment>
            </div>
        </el-dialog>        
    </div>
</template>
<script>
import printAdvancePayment from '@/components/printModels/printAdvancePayment';
export default {
    name: '',
    props: ['EntpCusId', 'EntpCusName'],
    components: {printAdvancePayment},
    data() {
        return {
            loading: false,
            tableData: [],
            searchDataLength: 0,
            searchData: {
                CusId: '',
                StartDate: '',
                EndDate: '',  
                PayStartDate:'',
                PayEndDate:'',                              
                Page: 1,
                Limit: 10
            },
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            total: 0,
            advanMoney: 0,
            datetime1: [],
            datetime2: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },     
            permission1: {},
            permission2: {},
            printPreviews: false       
        };
    },
    mounted() {
        this.permission1 = this.$util.getPermission('SupPayable_H');
        this.permission2 = this.$util.getPermission('supplier');
        this.searchData.CusId = this.EntpCusId;
        if (this.EntpCusName) {
            this.cusOptions.push({
                EntpCusId: this.EntpCusId,
                EntpCusName: this.EntpCusName
            });
        }
        this.getApplyHistory();
    },
    methods: {
        cancel() {
            this.$emit('closeReceipt');
        },
        cancelPayRecord(id) {
            if (id) {
                this.$confirm('是否撤销该条预付款申请？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/EntpSuppliers/CancelAdvancePaymentRecord?RecordId=${id}`,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('撤销成功');
                                this.getApplyHistory();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效预付款记录');
            }
        },
        backState(id) {
            if (id) {
                this.$confirm('是否反结算该条已确认的预付款？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        this.loading = true;
                        this.$util
                            .axiosPost({
                                url: `/api/EntpSuppliers/BackStateAdvanceReceivedRecord?RecordId=${id}`,
                                hideLoading: true
                            })
                            .then(res => {
                                this.$util.successMsg('反结算成功');
                                this.getApplyHistory();
                            })
                            .finally(() => {
                                this.loading = false;
                            });
                    })
                    .catch(() => {});
            } else {
                this.$util.warningMsg('请选择有效预付款记录');
            }
        },
        getApplyHistory() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpSuppliers/GetCusAdvancePaymentRecords',
                    hideLoading: true,
                    data: this.searchData
                })
                .then(res => {
                    if (!res.data) return;
                    this.tableData = res.data.DataList;
                    this.searchDataLength = res.count;
                    this.total = res.data.Total;
                    this.advanMoney = res.data.AdvanMoney;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getApplyHistory();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getApplyHistory();
        },
        async querySearch(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            let data = await this.$util.searchSupplier(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);

            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchLoad() {
            this.cusForm.Page += 1;
            this.querySearch();
        },
        handleSearch() {
            this.getApplyHistory();
        },
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },   
         onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.PayStartDate = val[0];
                this.searchData.PayEndDate = val[1];
            } else {
                this.searchData.PayStartDate = '';
                this.searchData.PayEndDate = '';
            }
        },
        closePrintDialog() {
            this.printPreviews = false;
        },
        printPreview() {
            let LODOP = this.$lodop.getLodop();
            if (!LODOP) return;

            if (this.tableData.length == 0) {
                this.$util.warningMsg('没有可打印的数据');
                return;
            }
            this.printPreviews = true;
        }                    
    }
};
</script>
<style lang="less" scoped>
.dialog-content {
    margin: 5px;
}
.btn-ctn {
    text-align: right;
}
.el-row {
    margin-bottom: 0px;
    &:last-child {
        margin-bottom: 0;
    }
}
</style>
